
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"Light","xmlns":"http://www.w3.org/2000/svg","width":"18","height":"18","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#2B2B2B","fill-rule":"evenodd"}},[_c('defs'),_c('circle',{staticClass:"cls-1",attrs:{"cx":"12","cy":"2.75","r":"2.25"}}),_c('path',{staticClass:"cls-1",attrs:{"d":"M16.5 9.5a4.644 4.644 0 00-9 0zM12 13.5v-2M6.5 13.5l1.5-2M17.5 13.5l-1.5-2"}}),_c('circle',{staticClass:"cls-1",attrs:{"cx":"12.086","cy":"18.35","r":"2.35"}}),_c('circle',{staticClass:"cls-1",attrs:{"cx":"4.694","cy":"18.35","r":"2.35"}}),_c('circle',{staticClass:"cls-1",attrs:{"cx":"19.314","cy":"18.35","r":"2.35"}}),_c('path',{staticClass:"cls-1",attrs:{"d":"M23 23.5a4.683 4.683 0 00-7.292 0A4.861 4.861 0 0012 21.76M1 23.5a4.683 4.683 0 017.292 0A4.861 4.861 0 0112 21.76"}})])])
          )
        }
      }
    